import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { unavailableParticipantStatuses } from 'app/frontend/types/custom/EventParticipantStatus'
import { useTeamEventParticipantsContext } from '../context/TeamEventParticipantsContext'
import { useTeamEventUpdateContext } from '../context/TeamEventUpdateContext'

const EventBulkSelectionMenuItem = () => {
  const { allEntries, activityIssuesById, activeActivityIds } =
    useTeamEventParticipantsContext()
  const { updateSelectionForAllActivities, isSaving } =
    useTeamEventUpdateContext()

  const selectableParticipantCount = allEntries.filter(
    (entry) =>
      !unavailableParticipantStatuses.includes(entry.participant.status),
  ).length
  const activeActivityIdList = Array.from(activeActivityIds)
  const allSelected =
    selectableParticipantCount > 0 &&
    activeActivityIdList.length > 0 &&
    activeActivityIdList.every(
      (activityId) =>
        activityIssuesById.get(activityId)?.selectedCount ===
        selectableParticipantCount,
    )

  return (
    <DropdownMenuItem
      disabled={activeActivityIdList.length === 0 || isSaving}
      onSelect={() => {
        updateSelectionForAllActivities(activeActivityIdList, !allSelected)
      }}
    >
      {allSelected ? 'Bench all participants' : 'Select all participants'}
    </DropdownMenuItem>
  )
}

export default EventBulkSelectionMenuItem
